import '@/styles/featurePopup.css'
import { useSafeTheme } from '@/theme/hooks'
import { X } from 'lucide-react'
import PropTypes from 'prop-types'

// Cadre commun a toutes les bulles rendues en React : clic carte et recherche.
const PopupShell = ({
  titre,
  icone: Icone,
  onClose,
  dataCy,
  actions,
  children,
}) => {
  const { theme, isDark } = useSafeTheme()
  const voile = isDark ? 'rgba(18,21,26,0.72)' : 'rgba(255,255,255,0.78)'

  return (
    <div
      className="w-72 max-w-full overflow-hidden rounded-xl border font-sans shadow-sm backdrop-blur-md"
      style={{
        backgroundColor: voile,
        borderColor: theme.border.primary,
        color: theme.text.primary,
      }}
    >
      <div
        className="flex items-center gap-2 border-b pl-3 pr-1"
        style={{ borderColor: theme.border.primary }}
      >
        {Icone && (
          <Icone
            size={14}
            className="shrink-0"
            style={{ color: theme.text.tertiary }}
          />
        )}
        <h3 className="min-w-0 flex-1 break-words text-xs font-semibold">
          {titre}
        </h3>
        {actions}
        <button
          type="button"
          onClick={onClose}
          aria-label="Fermer"
          className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg transition-colors hover:bg-black/5 dark:hover:bg-white/10"
          data-cy={dataCy}
        >
          <X size={14} />
        </button>
      </div>

      {children}
    </div>
  )
}

PopupShell.propTypes = {
  titre: PropTypes.node.isRequired,
  icone: PropTypes.elementType,
  onClose: PropTypes.func.isRequired,
  dataCy: PropTypes.string,
  actions: PropTypes.node,
  children: PropTypes.node,
}

export default PopupShell
